// Deprecated
// This hook shouldn't be used anymore.

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ShipTimeStatus } from 'inventory/enums';
import { inventoryService } from 'inventory/services';
import { ILeadTimeSuggestionsPayload } from 'quotes/types';

interface IShipTimeStatusResult {
  error?: string;
  message: ShipTimeStatus;
  success: boolean;
}

export const useShipTimeChecker = () => {
  const DEFAULT_INTERVAL_MILLISECONDS = 2000;

  const { t } = useTranslation();

  const onCheckShipTimeStatus = useCallback(
    async (
      payload: ILeadTimeSuggestionsPayload,
      checkIntervalId: NodeJS.Timer,
      finishedCallback: () => void,
      stoppedCallback: (error?) => void,
      abortController?: AbortController
    ) => {
      try {
        const result = await inventoryService.getShipTimeStatus(
          {
            quote: payload?.quoteId,
            part: payload?.partNumber,
            manufacturer: payload?.manufacturerId,
          },
          abortController?.signal || undefined
        );

        if (!result || !result?.success || result?.error) {
          abortController?.abort();
          clearInterval(checkIntervalId);

          stoppedCallback({
            ...result,
            message: result?.error || t('serverError'),
            success: false,
          });

          return;
        }

        onCheckSuccess(result, checkIntervalId, finishedCallback, abortController);
      } catch (error) {
        stoppedCallback(error);
      }
    },
    [t]
  );

  const checkShipTimeStatus = useCallback(
    (
      payload: ILeadTimeSuggestionsPayload,
      finishedHandler: (data?) => void,
      stopppedHandler: (data) => void,
      intervalMiliseconds = DEFAULT_INTERVAL_MILLISECONDS
    ) => {
      const abortController = new AbortController();

      const checkIntervalId = setInterval(() => {
        onCheckShipTimeStatus(
          payload,
          checkIntervalId,
          finishedHandler,
          stopppedHandler,
          abortController
        );
      }, intervalMiliseconds);
    },
    [onCheckShipTimeStatus]
  );

  const onCheckSuccess = async (
    result: IShipTimeStatusResult,
    checkIntervalId: NodeJS.Timer,
    finishedCallback: (data?) => void,
    abortController?: AbortController
  ) => {
    switch (result.message) {
      case ShipTimeStatus.FINISHED:
        abortController.abort();
        clearInterval(checkIntervalId);

        finishedCallback();

        break;
      default:
    }
  };

  return {
    checkShipTimeStatus,
  };
};
